import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {deletePaymentForm} from "../store/actions/paymentForm";
import {Alert, Button, Spinner} from "reactstrap";


type PaymentDeleteType = {
    deletePaymentForm: (id: number) => void
    cancelHandler?: () => void
    id: number
    changeLoading: boolean
    changeError: string
}

class PaymentDeleteContainer extends Component<PaymentDeleteType> {

    render() {
        const {id, changeLoading, changeError, cancelHandler, deletePaymentForm} = this.props;

        return (
            <>
                {changeError &&
                (<Alert className={'mt-3'} color={'danger'}>
                    {changeError}
                </Alert>)}
                <div className={'text-right'}>
                    {cancelHandler &&
                    <Button onClick={cancelHandler} color={'primary'} className={'mr-3'}>Не удалять</Button>}
                    <Button onClick={() => deletePaymentForm(id)} color={'danger'} disabled={changeLoading}>
                        {changeLoading &&
                        (<Spinner

                            size="sm"
                        />)}
                        Да, удалить
                    </Button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => {
    const {changeLoading, changeError} = state.paymentForm;

    return {
        changeLoading,
        changeError
    }
};

const mapDispatchToProps = {
    deletePaymentForm
};


export default connect(mapStateToProps, mapDispatchToProps)(PaymentDeleteContainer);
